import React, { useState, useRef, useEffect } from 'react';
import { Link } from "react-router-dom";
import "bootstrap-daterangepicker/daterangepicker.css";
import { Dropdown, Tab, Nav, } from "react-bootstrap";
import { get_BlogSingleData, get_BlogData, } from '../../../store/actions/CommanAction';
import { useDispatch, useSelector } from 'react-redux';
import { AddUpdate } from '../../../ApiMethods/ApiMethods';
import swal from "sweetalert";
import DataTable from 'react-data-table-component';
import { customStyles } from '../Utility/Utility';
import { setBlogID } from '../../../store/Action_Types';
import Loader from '../Loader/Loader';
import Modal from 'react-bootstrap/Modal';
import BlogAdd from './BlogAdd';

const BlogList = () => {

    const dispatch = useDispatch()
    const BlogData = useSelector((state) => state.feedBackReducer.BlogData);
    const customerID = Number(sessionStorage.getItem('ID'));
    const [IsActive, setIsActive] = useState(true);
    const [searchQuery, setSearchQuery] = useState('');
    const [blogID, setblogID] = useState('');
    const [loading, setloading] = useState(false);
    const [showBlogAddModal, setShowBlogAddModal] = useState(false);


    useEffect(() => {
        if (IsActive) {
            dispatch(get_BlogData('1', setloading))
        } else {
            dispatch(get_BlogData('0', setloading))
        }
    }, [IsActive]);

    useEffect(() => {
        blogID && setblogID(blogID)
    }, [blogID])

    const handleAddAstrologerClick = (BlogID) => {

        dispatch(setBlogID(BlogID));
    };

    const filteredAstroData = BlogData?.filter(item => {
        const query = searchQuery.toLowerCase();
        return (
            item.Title?.toLowerCase().includes(query) ||
            item.BlogCategoryValue?.toLowerCase().includes(query) ||
            item.AuthorName?.toLowerCase().includes(query) 
        );
    });
   

    const handleToggleStatusClick = async (blogID, currentStatus, isActiveValue) => {
        const postData = {
            'BlogID': blogID,
            'DeleteByUser': customerID,
            IsActive: !currentStatus ? '1' : '0',
        };
        await AddUpdate('Blog/Delete_Blog', postData);
        dispatch(get_BlogData(currentStatus ? '1' : '0', setloading));
        swal('Good job!', `Successfully ${isActiveValue === '1' ? 'Active' : 'Inactive'}`, "success");

    };

    const columns = [
        {
            name: 'AuthorName',
            cell: row => (
                <div className="concierge-bx d-flex align-items-center">
                    <div>
                        <h5 className="fs-16 mb-0 text-nowrap">
                            <Link
                                to={"/BlogHome"}
                                onClick={() => {
                                    handleAddAstrologerClick(row?.BlogID);
                                    setblogID(row?.BlogID);
                                }}
                                className="text-black"
                            >
                                {row.AuthorName}
                            </Link>
                        </h5>
                    </div>
                </div>
            ),
            sortable: true
        },
      
        {
      name: "Category",
      selector: (row) => row.BlogCategoryValue,
      sortable: true,
    
    },
        {
            name: 'Title', selector: (row) => row.Title, sortable: true,
            format: (row) => (
                <>{row?.Title ? row?.Title.substring(0, 50) : ''}{row?.Title?.length > 40 ? '  . . .' : null} </>
            ),
        },
         {
      name: "ReviewCount",
      selector: (row) => row.CountReViews,
      sortable: true,
    
    },
{
      name: "Is HomePage",
      selector: (row) => row.IsHomePage?"True":"False",
      sortable: true,
    
    },
    {
      name: "Is Trending",
      selector: (row) => row.IsTrending?"True":"False",
      sortable: true,
    
    },

    {
  name: "Created Date",
  selector: (row) => row.CreatedDtTm ? new Date(row.CreatedDtTm).toLocaleDateString() : "-",
  sortable: true,
},


        {
            name: <p className='text-end' style={{ position: 'absolute', top: '7px', right: 50 }}>Action</p>,
            cell: row => (
                <div style={{ position: 'absolute', top: 4, right: 50 }}>
                    <Dropdown>
                        <Dropdown.Toggle variant="" as="div" className="btn-link i-false">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z" stroke="#342E59" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z" stroke="#342E59" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z" stroke="#342E59" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </Dropdown.Toggle>
                        <Dropdown.Menu alignRight={true} className="dropdown-menu-right">

                            <Dropdown.Item className={row.IsActive ? "text-danger" : "text-success"}
                                onClick={() => {
                                    handleToggleStatusClick(row.BlogID, true, '0');
                                }}>
                                Inactive
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
            )
        }
    ];

    const columns1 = [
        {
            name: 'AuthorName',
            cell: row => (
                <div className="concierge-bx d-flex align-items-center">
                    

                    <div>
                        <h5 className="fs-16 mb-0 text-nowrap">
                            
                            {row.AuthorName}
                        </h5>
                        <span className="text-primary fs-14">{row.EMPID}</span>
                    </div>
                </div>
            ),
            sortable: true
        },
      
        {
            name: 'ShortDescription', selector: (row) => row.ShortDescription, sortable: true,
            format: (row) => (
                <>{row?.ShortDescription ? row?.ShortDescription.substring(0, 50) : ''}{row?.ShortDescription?.length > 40 ? '  . . .' : null} </>
            ),
        },
        {
            name: 'Title', selector: (row) => row.Title, sortable: true,
            format: (row) => (
                <>{row?.Title ? row?.Title.substring(0, 50) : ''}{row?.Title?.length > 40 ? '  . . .' : null} </>
            ),
        },
         {
      name: "ReviewCount",
      selector: (row) => row.CountReViews,
      sortable: true,
    
    },
    {
      name: "Is HomePage",
      selector: (row) => row.IsHomePage,
      sortable: true,
    
    },
    {
      name: "Is Trending",
      selector: (row) => row.IsTrending,
      sortable: true,
    
    },
         {
    name: "Created Date",
      selector: (row) => row.CreatedDtTm,
      sortable: true,
    
    },
        {
            name: <p className='text-end' style={{ position: 'absolute', top: '7px', right: 50 }}>Action</p>,
            cell: row => (
                <div style={{ position: 'absolute', top: 4, right: 50 }}>
                    <Dropdown>
                        <Dropdown.Toggle variant="" as="div" className="btn-link i-false">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z" stroke="#342E59" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z" stroke="#342E59" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z" stroke="#342E59" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </Dropdown.Toggle>
                        <Dropdown.Menu alignRight={true} className="dropdown-menu-right">
                            <Dropdown.Item className={row.IsActive ? "text-danger" : "text-success"}
                                onClick={() => {
                                    handleToggleStatusClick(row.BlogID, false, '1');
                                }}>
                                Activate
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
            )
        }
    ];


    return (
        <>
            <Tab.Container defaultActiveKey="All">
        <h2 style={{ color: '#f7931e', fontWeight: 700 }}>Blog List</h2>
                <div className="mt-2 d-flex justify-content-between align-items-center flex-wrap main_card">
                    <div className="card-action coin-tabs mb-2">
                        <Nav variant="tabs">
                            <Nav.Item as="li" className="nav-item">
                                <Nav.Link
                                    className={`nav-link ${IsActive ? 'active' : ''}`}
                                    onClick={() => { setIsActive(true); setSearchQuery(''); }}
                                >
                                    Active
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item as="li" className="nav-item">
                                <Nav.Link
                                    className={`nav-link ${!IsActive ? 'active' : ''}`}
                                    onClick={() => { setIsActive(false); setSearchQuery(''); }}
                                >
                                    Inactive
                                </Nav.Link>
                            </Nav.Item>
                        </Nav>
                    </div>
                    <Link
                        to="#"
                        onClick={e => { e.preventDefault(); setShowBlogAddModal(true); handleAddAstrologerClick(null); }}
                        className="btn btn-primary font-w600 "
                    >
                        Add Blog
                    </Link>
                    <div style={{}} className="input-group search-area text-end" >
                        <input
                            type="text"
                            style={{border:"2px solid #F7931E"}}
                            className={`form-control text-dark`}
                            placeholder="Search Category..."
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                        />
                       
                    </div>
                </div>
                <div className="row mt-4">
                    <div className="col-xl-12">
                        <div className="card">
                            <div className="card-body p-0">
                                <Tab.Content>
                                    <Tab.Pane eventKey="All">
                                        <div className="table-responsive">
                                            {
                                                IsActive ?
                                                    <>
                                                        {
                                                            loading ?
                                                                <Loader />
                                                                :
                                                                <DataTable
                                                                    dense
                                                                    data={filteredAstroData}
                                                                    columns={columns}
                                                                    selectableRowsHighlight
                                                                    highlightOnHover
                                                                    pagination
                                                                    persistTableHead={true}
                                                                    noDataComponent={"There are no data to display"}
                                                                    customStyles={customStyles}
                                                                />
                                                        }
                                                    </>
                                                    :
                                                    <>
                                                        {
                                                            loading ?
                                                                <Loader />
                                                                :
                                                                <DataTable
                                                                    dense
                                                                    data={filteredAstroData}
                                                                    columns={columns1}
                                                                    selectableRowsHighlight
                                                                    pagination
                                                                    persistTableHead={true}
                                                                    noDataComponent={"There are no data to display"}
                                                                    customStyles={customStyles}
                                                                />
                                                        }
                                                    </>
                                            }
                                        </div>
                                    </Tab.Pane>
                                </Tab.Content>
                            </div>
                        </div>
                    </div>
                </div>
            </Tab.Container >
            <Modal
                show={showBlogAddModal}
                onHide={() => setShowBlogAddModal(false)}
                size="xl"
                centered
                backdrop="static"
                keyboard={false}
                className="custom-modal-centered border-0"
            >
                <Modal.Header closeButton>
                    <Modal.Title> <h2 className="heading mb-0">Add Blog</h2></Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ maxHeight: '80vh', overflowY: 'auto ' }}>
                    <BlogAdd onClose={() => setShowBlogAddModal(false)   }
                                modalOpen={showBlogAddModal}
                    />
                </Modal.Body>
            </Modal>

        </>
    )
}
export default BlogList